<header class="background-header">
    <img src="../../assets/img/{{themeService.theme}}/header-background.svg" alt="" class="background-header-img"
        [ngClass]="{backgroundWidth: themeService.theme == 'white-label' || themeService.theme == 'life-file' && themeService.theme != 'boosst'}">
</header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true}">
    <section class="container my-dashboard-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>My Plan <i class="fa fas fa-chevron-right"></i></span>
                <app-breadcrumb [pageName]="'Testing'" [isTopLevel]="true"></app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>Testing</h1>
            </div>
            
        </section>
        
    </section>
</section>